
<sm-title-bar [pageTitle]="bookingType == '0' ? 'Home Bookings' : (bookingType == '1' ? 'Shop Bookings' : 'Virtual Bookings')" [backWithParams]="true" 
[headerCustomTemplate]="addButton">
  <ng-template #addButton>
    <div class="d-flex search-field">
      <div class="booking_sectionkl">
        <div class="Create_header_btn">
          <button mat-icon-button color="primary" [matMenuTriggerFor]="menu"> <mat-icon>add</mat-icon></button>
          <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="createNewBooking()">
                <mat-icon class="material-icons-outlined">event</mat-icon>
                <span>New booking</span>
              </button>
              <button mat-menu-item (click)="addNewInterest()">
                <mat-icon class="material-icons-outlined"
                  >card_membership</mat-icon
                >
                <span>New membership request</span>
              </button>
            </mat-menu>
       </div>
       <div class="booking_sedr">
        <button mat-icon-button color="primary" (click)="refreshScreen()" >
          <mat-icon class="material-icons-round" [inline]="true" style="font-size: 22px; position: relative; top: 0px;">refresh</mat-icon>
      </button>
      </div>
      </div>
    </div>
  </ng-template>
</sm-title-bar>

<!-- 
<div class="page-title-bar mb-4">
 <div class="customer_flexc">
  <div class="title d-flex">
    <div class="custgomner_wallet">
    <button mat-icon-button class="me-3">
      <mat-icon class="material-icons-round">arrow_back</mat-icon>
      </button>
     </div>
    <div>
      <div class="rt_tht">
      <h1>{{bookingType == '0' ? 'Home Bookings & Query' : (bookingType == '1' ? 'Shop Bookings & Query' : 'Virtual Bookings & Query')}}</h1>
    </div>
    </div>
  </div>
  
 <div class="Create_header_btn">
          <button mat-icon-button color="primary" [matMenuTriggerFor]="menu"> <mat-icon>add</mat-icon></button>
          <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="createNewBooking()">
                <mat-icon class="material-icons-outlined">event</mat-icon>
                <span>New booking</span>
              </button>
              <button mat-menu-item (click)="addNewInterest()">
                <mat-icon class="material-icons-outlined"
                  >card_membership</mat-icon
                >
                <span>New membership request</span>
              </button>
            </mat-menu>
       </div>
        <div class="booking_sedr">
        <button mat-icon-button color="primary" (click)="refreshScreen()" >
          <mat-icon class="material-icons-round" [inline]="true" style="font-size: 22px; position: relative; top: 0px;">refresh</mat-icon>
      </button>
      </div>
</div>
</div> -->




<div class="chip_cont">
  <div class="booing_sectyy">
  <mat-chip-listbox aria-label="Fish selection" class="mb-1">
    <mat-chip
      style=" margin-right: 12px;"
      [ngClass]="{ selected: selectedValue == '0' }"
      (click)="changeChip('0')"
      >{{ 'business_bookings.today' | translate }}
    </mat-chip>
  </mat-chip-listbox>

  <mat-chip-listbox aria-label="Fish selection" class="mb-3">  
    <mat-chip
     
      [ngClass]="{ selected: selectedValue == '1' }"
      (click)="changeChip('1')"
      >{{ 'business_bookings.tomorrow' | translate }}
    </mat-chip>
  </mat-chip-listbox>
   <mat-chip-listbox aria-label="Fish selection" class="mb-3">  
    <mat-chip
      style="height: auto"
      [ngClass]="{ selected: selectedValue == '2' }"
      (click)="changeChip('2')"
      >Membership request
    </mat-chip>
  </mat-chip-listbox>
  <mat-chip-listbox aria-label="Fish selection" class="mb-3">  
    <mat-chip
      style="height: auto"
      [ngClass]="{ selected: selectedValue == '3' }"
      (click)="changeChip('3')"
      >Customer queries
    </mat-chip>
  </mat-chip-listbox>
</div>


  
</div>

<div *ngIf="loader" class="loader">
  <mat-spinner></mat-spinner>
</div>
<!-- <mat-card appearance="outlined" *ngIf="visible && !loader && bookingsData.length > 0">
  <mat-card-header class="justify-content-between align-items-center mb-3">
  </mat-card-header>
  <div class="rounded-3 bg-light">
    <sm-data-table
      [columnHeaders]="tableDisplayColumns"
      [dataSource]="bookingsData"
      [showPagination]="true"
      [itemsPerPage]="25"
      [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate"
    >

    <ng-template #costTemplate let-rowVal="row" let-colVal="col">
      {{rowVal[colVal.columnProperty] | currency: 'INR'}}
    </ng-template>
    </sm-data-table>
  </div>
</mat-card> -->



<div class="busroy" *ngIf="visible && !loader && bookingsData.length > 0 && (selectedValue == '0' || selectedValue == '1')">
<mat-card *ngFor="let item of bookingsData" (click)="bookingDetails(item)">
  <div class="s">
    <div class="booking-header">
      <div class="left-section" style="position: relative;">
        <mat-icon
        *ngIf="!item.customerInfo.imgThumbUrl || item.customerInfo.imgThumbUrl == 'null'"
        [class.new-booking]="item.bookingStatus == 0 ||item.bookingStatus == 1 || item.bookingStatus == 2" [class.under-process]="item.bookingStatus == 3 || item.bookingStatus == 7 || item.bookingStatus == 9" [class.completed]="item.bookingStatus == 4" [class.cancelled]="item.bookingStatus == 6 || item.bookingStatus == 8" [class.confirmed]="item.bookingStatus == 5"
            class="status-icon"></mat-icon>
        <mat-icon
        *ngIf="item.customerInfo.imgThumbUrl && item.customerInfo.imgThumbUrl != 'null'"
        [class.new-booking]="item.bookingStatus == 0 ||item.bookingStatus == 1 || item.bookingStatus == 2" [class.under-process]="item.bookingStatus == 3 || item.bookingStatus == 7 || item.bookingStatus == 9" [class.completed]="item.bookingStatus == 4" [class.cancelled]="item.bookingStatus == 6 || item.bookingStatus == 8" [class.confirmed]="item.bookingStatus == 5"
            class="status-icon"></mat-icon>
        <div class="booking-initial" *ngIf="!item.customerInfo.imgThumbUrl || item.customerInfo.imgThumbUrl == 'null'">{{item.cust_name.slice(0,1).toUpperCase()}}</div>
        <img class="booking-initial-img img-fluid rounded-circle" [src]="item.customerInfo.imgThumbUrl" alt="" *ngIf="item.customerInfo.imgThumbUrl && item.customerInfo.imgThumbUrl != 'null'" onerror="this.src='../../../../assets/images/user-avatar.svg'">
        <div class="booking-details">
          <h3 class="booking-name">{{item.cust_name}}</h3>
          <!-- <h2 class="booking-number">   #{{item.appointment_no}}</h2> -->

          <p class="booking-number">  <span class="bookingstar">{{item.bookingStartTime}} - {{item.bookingEndTime}},</span> #{{item.appointment_no}}</p>
        </div>
      </div>
      <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
        <mat-icon>more_vert</mat-icon>
      </button> -->
      <mat-menu #menu="matMenu">
        <!-- <button mat-menu-item *ngIf="((item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2) && (item.customerInfo.hash_id && item.customerInfo.hash_id != 'null'))" (click)="confirmBooking(item)">
          <mat-icon class="material-icons-outlined">check_circle</mat-icon>
          <span>{{ 'business_bookings.opt_confirm_booking' | translate }}</span>
        </button>
        <button mat-menu-item *ngIf="(item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2 || item.bookingStatus == 7 || item.bookingStatus == 9 || item.bookingStatus == 5) && selectedValue == '0'" (click)="startProcess(item)">
          <mat-icon class="material-icons-outlined">timer</mat-icon>
          <span>{{ 'business_bookings.opt_start_process' | translate }}</span>
        </button>
        <button mat-menu-item *ngIf="(item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2 || item.bookingStatus == 7 || item.bookingStatus == 9 || item.bookingStatus == 5)  && selectedValue == '0'" (click)="assignJob(item)">
          <mat-icon class="material-icons-outlined">assignment_ind</mat-icon>
          <span>{{ 'business_bookings.opt_assign_job' | translate }}</span>
        </button>
        
        <button mat-menu-item *ngIf="(item.bookingStatus == 3 || item.bookingStatus == 5) && selectedValue == '0'" (click)="done(item)">
          <mat-icon class="material-icons-outlined">task_alt</mat-icon>
          <span>{{ 'business_bookings.opt_done' | translate }}</span>
        </button>
        <button mat-menu-item *ngIf="(item.bookingStatus == 3 || item.bookingStatus == 9 || item.bookingStatus == 4) && isOwner && selectedValue == '0'" (click)="customiseBooking(item)">
          <mat-icon class="material-icons-outlined">tune</mat-icon>
          <span>Edit data</span>
        </button>
        <button mat-menu-item *ngIf="(item.bookingStatus != 4 && item.bookingStatus != 6 && item.bookingStatus != 8) && bookingType == '2'" (click)="addEditMeetingData(item)">
      <mat-icon class="material-icons-outlined">video_chat</mat-icon>
      <span>Meeting info</span>
    </button>
        <button mat-menu-item *ngIf="(item.bookingStatus == 3 || item.bookingStatus == 9 || item.bookingStatus == 4 || item.bookingStatus == 7)  && isOwner && selectedValue == '0'" (click)="reset(item)">
          <mat-icon class="material-icons-outlined">restart_alt</mat-icon>
          <span>{{ 'business_bookings.opt_reset_to_new' | translate }}</span>
        </button> -->
        <!-- <button mat-menu-item *ngIf="item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2 || item.bookingStatus == 7 || item.bookingStatus == 3 || item.bookingStatus == 9 || item.bookingStatus == 4 || item.bookingStatus == 8 || item.bookingStatus == 6 || item.bookingStatus == 5" (click)="bookingDetails(item)">
          <mat-icon class="material-icons-outlined">info</mat-icon>
          <span>{{ 'business_bookings.opt_booking_details' | translate }}</span>
        </button> -->
        <!-- <button mat-menu-item *ngIf="item.bookingStatus == 4 && selectedValue == '0'" (click)="openInvoice(item)">
          <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
          <span>{{ 'business_bookings.opt_invoice' | translate }}</span>
        </button>
        <button mat-menu-item *ngIf="((item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2 || item.bookingStatus == 5) && isOwner)" (click)="cancelBooking(item)">
          <mat-icon class="material-icons-outlined">cancel</mat-icon>
          <span>{{ 'business_bookings.opt_cancel_booking' | translate }}</span>
        </button>
        <button mat-menu-item *ngIf="(!item.customerInfo.hash_id || item.customerInfo.hash_id == 'null') && isOwner && selectedValue == '0'" (click)="deleteBooking(item)">
          <mat-icon class="material-icons-outlined">delete</mat-icon>
          <span>Delete booking</span>
        </button> -->
    </mat-menu>
    </div>
    <p class="booking-meta">
      <span class="addign">Assigned to: </span> <span class="addign">{{item.employeeName}}</span>
    </p>
    <p class="booking-meta">
      <span class="label">Status: </span>
      <span class="value" >{{item.bookingStat}}</span> 
      <span class="label" *ngIf="item.paymentStat && item.paymentStat != '---'">, Payment: </span> <span class="value"  *ngIf="item.paymentStat && item.paymentStat != '---'">{{item.paymentStat}}</span>
    </p>
   <p class="date_booking">{{item.cust_phn}}  
  </p>

  <div class="arrow_iocn_x">
    <mat-icon>arrow_forward</mat-icon>
  </div>
  </div>
</mat-card>
    
  </div>


  <!-- placeholder html start -->
  <div class="placeholder_started" *ngIf="visible && !loader && bookingsData.length == 0 && (selectedValue == '0' || selectedValue == '1')">
        <div class="row">
          <div class="col-12 col-md-4" *ngIf="selectedValue == '0'">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/bookings-pp.png">
                 </div>
                 <mat-card-title>No bookings for today.</mat-card-title>
                 <mat-card-content>There's no booking done by any customer or from the house for today. Though you can create one from here.

                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="createNewBooking()">
                      <mat-icon>add</mat-icon>
                      New booking
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-12 col-md-4" *ngIf="selectedValue == '1'">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/bookings-pp.png">
                 </div>
                 <mat-card-title>No bookings for tomorrow.</mat-card-title>
                 <mat-card-content>For any difficulties in creating a new business or if there's any issue with subscription, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="createNewBooking()">
                       <mat-icon>add</mat-icon>
                       New booking
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="/assets/images/new-booking.png">
                 </div>
                 <mat-card-title>How to create a new booking?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new booking against a business. You can check this video as well. 

                </mat-card-content>
                <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="openvideo()">
                     <mat-icon>play_arrow</mat-icon>
                     Watch video
                  </button>
               </div>
                 </div>
              </mat-card>
           </div>
          </div>
       
          <div class="col-12 col-md-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in creating a new booking or in issue in getting booking list data, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div> 
  <!-- placeholder html end -->




<!-- MEMBERSHIP QUERIES START -->
<div
  class="busroy"
 *ngIf="visible && !loader && interestData.length > 0  && selectedValue == '2'"
>
  <div class="row">
    <div
      class="col-sm-4"
      *ngFor="let item of interestData"
      (click)="viewDetails(item)"
    >
      <mat-card>
        <div class="booking-card">
          <div class="booking-header">
            <div class="left-section" style="position: relative">
              <mat-icon
                [class.new-booking]="item.enrollment_request_status == 1"
                [class.under-process]="item.enrollment_request_status == 2"
                [class.completed]="item.enrollment_request_status == 5"
                [class.cancelled]="item.enrollment_request_status == 4"
                [class.confirmed]="item.enrollment_request_status == 3"
                class="status-icon"
              ></mat-icon>
              <div
                class="booking-initial"
                *ngIf="!item.image_thumb_url || item.image_thumb_url == 'null'"
              >
                {{ item.customer_name.slice(0, 1) }}
              </div>
              <img
                class="booking-initial-img img-fluid rounded-circle"
                [src]="item.image_thumb_url"
                alt=""
                *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'"
                onerror="this.src='../../../../assets/images/user-avatar.svg'"
              />
              <div class="booking-details">
                <h3 class="booking-name">{{ item.customer_name }}</h3>
                <p class="booking-number">
                  <span
                    class="bookingstar"
                    style="font-size: 14px; color: #888"
                    >{{ item.phone }}</span
                  >
                </p>
              </div>
            </div>

            <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
         <mat-icon>more_vert</mat-icon>
       </button> -->
          </div>

          <p class="booking-meta">
            <!-- <span class="label">Phone: </span> <span class="value"></span>,  -->
            <span class="label">Status: </span>
            <span class="value">{{ item.item_status }}</span>
          </p>
          <p class="booking-meta">
            <span class="label">Services: </span>
            <span class="value">{{ item.opted_services }} </span>
            <!-- <span class="value">{{item.bookingStartTime}} - {{item.bookingEndTime}}</span>  -->
          </p>
          <p class="booking-meta">
            <span class="value">{{ item.creation_time | date }}</span>
          </p>
        </div>
        <div class="arrow_iocn_x">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </mat-card>
    </div>
  </div>
</div>

<!-- placeholder html start -->
<div
  class="placeholder_started"
 *ngIf="visible && !loader && interestData.length == 0  && selectedValue == '2'"
>
  <div class="row">
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/query-s1.jpg" />
            </div>
            <mat-card-title>No queries to show.</mat-card-title>
            <mat-card-content
              >All the queries will appear here between the selected date range.
              It seems you haven't started operations or check the selected
              dates.
            </mat-card-content>
            <!-- <div class="watch_vc_btn" *ngIf="interestType != '4'">
                     <button mat-stroked-button color="primary"  (click)="addNewInterest()">
                        <mat-icon>add</mat-icon>
                        Add new query 
                     </button>
                  </div> -->
          </div>
        </mat-card>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="/assets/images/new-booking.png" />
            </div>
            <mat-card-title>How to create a new query?</mat-card-title>
            <mat-card-content
              >Check our
              <span
                class="ghtunderline"
                (click)="openLink('https://lookzup.com/help')"
              >
                help document
              </span>
              on creating new query against a business. You can check this video
              as well.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button mat-stroked-button color="primary" (click)="openvideo()">
                <mat-icon>play_arrow</mat-icon>
                Watch video
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/helpsupport.png" />
            </div>
            <mat-card-title>Facing any issue?</mat-card-title>
            <mat-card-content
              >For any difficulties in adding a new query or issue with managing
              them, contact our support team.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button
                mat-stroked-button
                color="primary"
                (click)="opencontact()"
              >
                <mat-icon>support_agent</mat-icon>
                Contact support
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
<!-- placeholder html end -->

<!-- MEMBERSHIP QUERIES END -->

<!-- QUERIES START -->
<div
  class="busroy"
  *ngIf="visible && !loader && queryData.length > 0  && selectedValue == '3'"
>
  <div class="row">
    <div
      class="col-sm-4"
      *ngFor="let item of queryData"
      (click)="viewDetailsforservicequery(item)"
    >
      <mat-card>
        <div class="booking-card">
          <div class="booking-header">
            <div class="left-section" style="position: relative">
              <mat-icon
                [class.new-booking]="item.status == 1"
                [class.under-process]="item.status == 2"
                [class.completed]="item.status == 3"
                class="status-icon"
              ></mat-icon>
              <div
                class="booking-initial"
                
              >
                {{ item.name.slice(0, 1) }}
              </div>
              <!-- <img
                class="booking-initial-img img-fluid rounded-circle"
                [src]="item.image_thumb_url"
                alt=""
                *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'"
                onerror="this.src='../../../../assets/images/user-avatar.svg'"
              /> -->
              <div class="booking-details">
                <h3 class="booking-name">{{ item.name }}</h3>
                <p class="booking-number">
                  <span
                    class="bookingstar"
                    style="font-size: 14px; color: #888"
                    >{{ item.phone }}</span
                  >
                </p>
              </div>
            </div>

            <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
         <mat-icon>more_vert</mat-icon>
       </button> -->
          </div>

          <p class="booking-meta">
            <!-- <span class="label">Phone: </span> <span class="value"></span>,  -->
            <span class="label">Status: </span>
            <span class="value">{{ item.item_status }}</span>
          </p>
         
          <p class="booking-meta">
            <span class="value">{{ item.creation_time | date : 'MMM d, y, h:mm a' : 'UTC' }}</span>
          </p>
        </div>
        <div class="arrow_iocn_x">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </mat-card>
    </div>
  </div>
</div>

<!-- placeholder html start -->
<div
  class="placeholder_started"
 *ngIf="visible && !loader && queryData.length == 0  && selectedValue == '3'"
>
  <div class="row">
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/query-s1.jpg" />
            </div>
            <mat-card-title>No service queries to show.</mat-card-title>
            <mat-card-content
              >All the queries will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
            </mat-card-content>
            <!-- <div class="watch_vc_btn" *ngIf="interestType != '4'">
                     <button mat-stroked-button color="primary"  (click)="addNewInterest()">
                        <mat-icon>add</mat-icon>
                        Add new query 
                     </button>
                  </div> -->
          </div>
        </mat-card>
      </div>
    </div>
<!-- 
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="/assets/images/new-booking.png" />
            </div>
            <mat-card-title>How to create a new query?</mat-card-title>
            <mat-card-content
              >Check our
              <span
                class="ghtunderline"
                (click)="openLink('https://lookzup.com/help')"
              >
                help document
              </span>
              on creating new query against a business. You can check this video
              as well.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button mat-stroked-button color="primary" (click)="openvideo()">
                <mat-icon>play_arrow</mat-icon>
                Watch video
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div> -->
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/helpsupport.png" />
            </div>
            <mat-card-title>Facing any issue?</mat-card-title>
            <mat-card-content
              >For any difficulties contact our support team.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button
                mat-stroked-button
                color="primary"
                (click)="opencontact()"
              >
                <mat-icon>support_agent</mat-icon>
                Contact support
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
<!-- placeholder html end -->

<!-- QUERIES END -->
